module.exports = __webpack_public_path__ + "img/CtrlRoom_small_bg.f3e726e3.png";